<template>
  <div
    :style="{
      padding: '24px',
      margin: '24px 16px 24px 16px',
      background: '#fff',
      minHeight: '100px',
    }"
  >
    <h1 class="h1">【{{ updates.title }}】</h1>
    <a-button class="button" type="primary" @click="update">更新</a-button>

    <a-row>
      <span>内容</span>
    </a-row>
    <a-divider />
    <a-row class="icon">
      <a-icon type="snippets" />
      <a-icon type="font-colors" />
      <a-icon type="bold" />
      <a-icon type="italic" />
    </a-row>
    <a-row> 任务中心活动规则： </a-row>
    <a-row class="content">
      <!-- <a-textarea
        v-model="updates.content"
        placeholder="Basic usage"
        :rows="4"
      /> -->
      <quill-editor
        v-model="updates.content"
        ref="myQuillEditor"
        :options="editorOption"
        @blur="onEditorBlur($event)"
        @focus="onEditorFocus($event)"
        @change="onEditorChange($event)"
      >
      </quill-editor>
    </a-row>
  </div>
</template>

<script>
import { storeAgreement, updateuserDetails } from "@/api/storeApi.js";
import { message } from "ant-design-vue";
export default {
  name: "ProtocolRulesTwo",
  data() {
    return {
      updates: {
        objId: "",
        title: "任务中心",
        content: "",
        type: 1501,
      },
    };
  },
  mounted() {
    this.getstoreAgreement();
  },
  methods: {
    getstoreAgreement() {
      storeAgreement(1501).then((res) => {
        this.updates.title = res.data.title;
        this.updates.content = res.data.content;
        this.updates.objId = res.data.objId;
      });
    },
    update() {
      updateuserDetails(this.updates).then((res) => {
        message.success(res.data);
      });
    },
  },
};
</script>

<style scoped>
.content {
  margin-top: 20px;
  margin-left: 20px;
}
.button {
  position: relative;
  left: 500px;
  bottom: 50px;
  width: 100px;
  height: 40px;
}
.h1 {
  font-size: 28px;
}
.icon {
  height: 50px;
}
.icon a-icon {
  height: 50px;
}
</style>


// WEBPACK FOOTER //
// src/components/ProtocolRulesThree.vue